import React, { useRef } from 'react';
import axios from 'axios';
import { Icon, TooltipHost, Spinner, SpinnerSize } from '@fluentui/react';
import Api from '../../../services/Api';
import { useState } from 'react';

const DeleteAppPermission = ({appPermission, siteId, refresh, setMessage, setAppIsLoading}) => {
    const cancelToken = axios.CancelToken;

    const cancelSource = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const deleteAppPermission = () => {
        setAppIsLoading(true)
        setIsLoading(true);
        setMessage();

        if (cancelSource.current) {
            cancelSource.current.cancel();
        }
        
        cancelSource.current = cancelToken.source();

        const post = {
            removeAppPermission: appPermission,
            id: siteId
        }

        let url = `/AdminUpdateSiteRequest`;

        Api.post(url, post, { cancelToken: cancelSource.current.token})
        .then(res => res.data)
        .then(c => {
            setIsLoading(false);
            refresh(siteId);
        })
        .catch(error => {
            setIsLoading(false);
            console.log(error);
            setMessage(error.response.data.message, true);
        });

        return () => {
            cancelSource.current.cancel();
        }
    }

    return (
        <div>
            {
                isLoading 
                ? <Spinner size={SpinnerSize.medium} styles={actionStyles} />
                : appPermission.isActive && !appPermission.isEditing && 
                    <TooltipHost content="Delete Permission" styles={actionStyles}>
                        <Icon iconName="cancel" style={deleteIconStyles} onClick={deleteAppPermission}/>
                    </TooltipHost>
            }
        </div>
    );
}

const actionStyles = {
    root: {
        margin: 'auto'
    }
}

const deleteIconStyles = {
    cursor: 'pointer',
    margin: '0 5px',
    fontSize: '16px',
    fontWeight: '600'
}

export default DeleteAppPermission;


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/DeleteAppPermission.js